import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'poster-editing-item-animation-panel';

export default function PosterEditorItemAnimationModal(): ReactElement<any> {
  const [height, setHeight] = useState('174px');
  const maxWidth = '800px';
  const sizeData = useAppSelector((state) => {
    return state.panels.sizeDataHashmap[PANEL_ID];
  });

  useEffect((): void => {
    if (sizeData?.height) {
      setHeight(sizeData.height);
    }
  }, [sizeData]);

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_ITEM_ANIMATION_MODAL}
      panelId={PANEL_ID}
      mobileHeight={height}
      modalMaxWidth={maxWidth}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalHeight={height}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName={PANEL_ID}
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openItemAnimationModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_ITEM_ANIMATION_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
